/**
 * Bulk carton-label printing utilities.
 *
 * Single source of truth — used by Inventory Boxes Panel, Quick Weigh "Recent",
 * and Shift Stock. Opens a hidden iframe pointed at /labels/bulk with all the
 * selected box numbers; the bulk page renders them with page-breaks and fires
 * one window.print() so the thermal printer streams everything as one job.
 */
const BULK_FRAME_ID = "bulk-label-print-frame";

export function triggerBulkLabelPrint(boxNos) {
  const list = (boxNos || []).filter(Boolean);
  if (list.length === 0) return false;
  let frame = document.getElementById(BULK_FRAME_ID);
  if (!frame) {
    frame = document.createElement("iframe");
    frame.id = BULK_FRAME_ID;
    frame.setAttribute("data-testid", "bulk-label-print-frame");
    frame.style.position = "fixed";
    frame.style.right = "0";
    frame.style.bottom = "0";
    frame.style.width = "0";
    frame.style.height = "0";
    frame.style.border = "0";
    document.body.appendChild(frame);
  }
  const qs = new URLSearchParams({ box_nos: list.join(","), autoprint: "1" }).toString();
  frame.src = `/labels/bulk?${qs}`;
  return true;
}
